/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const DELETPROJECT= createAsyncThunk(
  "deleteProject/deleteProject",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const deleteProjectSlice = createSlice({
  name: "deleteProjectSlice",
  initialState: {
    deleteProject: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfdeleteProject: (state) => {
        state.deleteProject.loading = false
        state.deleteProject.error = false
        state.deleteProject.data = []
        state.deleteProject.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(DELETPROJECT.fulfilled, (state, action) => {
      state.deleteProject = {
        ...state.deleteProject,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DELETPROJECT.pending, (state, action) => {
      state.deleteProject = {
        ...state.deleteProject,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DELETPROJECT.rejected, (state, action) => {
      state.deleteProject = {
        ...state.deleteProject,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const deleteProjectAction = {
    DELETPROJECT,
};

export { deleteProjectAction };
export default deleteProjectSlice.reducer;
export const {setInitialStateOfdeleteProject} = deleteProjectSlice.actions